module.exports = __webpack_public_path__ + "static/media/400389_02.15e23121.png";